import {addToCart} from './addToCart';

const clearBasketEvents = (selector, events) => {
    document.querySelectorAll(selector).forEach(item => item.removeEventListener('click', addToCart.bind(null, events)));
};

export function initBasketEvents(selector, events) {
    document.querySelectorAll(selector).forEach(item => item.addEventListener('click', addToCart.bind(null, events), false));
}

export function reInitBasketEvents(selector, events) {
    clearBasketEvents(selector, events);
    initBasketEvents(selector, events);
}


